
import { useState, useEffect } from 'react';
import { getAnimationClass } from './../utils';
import TransactionsBox from './transactionsBox';
import AccountingEquation from './accountingEquation';

export default function IncreaseDecrease({ onComplete, numberOfAttempts }) {
  const [showTransactionsBox, setShowTransactionsBox] = useState(false);
  const [fadeOutTransactionsBox, setFadeOutTransactionsBox] = useState(false);
  
  const [showIntroP, setShowIntroP] = useState(false);
  const [fadeOutIntroP, setFadeOutIntroP] = useState(false);
  const [hideIntroP, setHideIntroP] = useState(false);

  const [showFirstSectionRight, setShowFirstSectionRight] = useState(false);
  const [fadeOutFirstSectionRight, setFadeOutFirstSectionRight] = useState(false);
  const [hideFirstSectionRight, setHideFirstSectionRight] = useState(false);
  
  const [showSecondP, setShowSecondP] = useState(false);
  const [fadeOutSecondP, setFadeOutSecondP] = useState(false);
  const [hideSecondP, setHideSecondP] = useState(false);

  const [showSecondSectionRight, setShowSecondSectionRight] = useState(false);
  const [fadeOutSecondSectionRight, setFadeOutSecondSectionRight] = useState(false);
  const [hideSecondSectionRight, setHideSecondSectionRight] = useState(false);
  
  const [showThirdP, setShowThirdP] = useState(false);
  const [fadeOutThirdP, setFadeOutThirdP] = useState(false);
  const [hideThirdP, setHideThirdP] = useState(false);

  const [showThirdSectionRight, setShowThirdSectionRight] = useState(false);
  const [fadeOutThirdSectionRight, setFadeOutThirdSectionRight] = useState(false);
  const [hideThirdSectionRight, setHideThirdSectionRight] = useState(false);

  const [showFourthP, setShowFourthP] = useState(false);
  const [fadeOutFourthP, setFadeOutFourthP] = useState(false);

  const [showFourthSectionRight, setShowFourthSectionRight] = useState(false);
  const [fadeOutFourthSectionRight, setFadeOutFourthSectionRight] = useState(false);

  const [showFifthP, setShowFifthP] = useState(false);

  useEffect(() => {
    const timeouts = [];
    let currentTime = 0;
    
    currentTime += 500;
    timeouts.push(setTimeout(() => setShowIntroP(true), currentTime));
    
    currentTime += 3000;
    timeouts.push(setTimeout(() => {
      setShowTransactionsBox(true);
      setShowFirstSectionRight(true);
    }, currentTime));
    
    currentTime += 6000;
    timeouts.push(setTimeout(() => {
      setFadeOutIntroP(true);
      setFadeOutFirstSectionRight(true);
      setShowSecondP(true);
    }, currentTime));
    
    currentTime += 500;
    timeouts.push(setTimeout(() => {
      setHideIntroP(true);
      setHideFirstSectionRight(true);
    }, currentTime));

    currentTime += 3000;
    timeouts.push(setTimeout(() => setShowSecondSectionRight(true), currentTime));

    currentTime += 5000;
    timeouts.push(setTimeout(() => {
      setFadeOutSecondP(true);
      setFadeOutSecondSectionRight(true);
      setShowThirdP(true);
    }, currentTime));
    
    currentTime += 500;
    timeouts.push(setTimeout(() => {
      setHideSecondP(true);
      setHideSecondSectionRight(true);
    }, currentTime));

    currentTime += 3000;
    timeouts.push(setTimeout(() => setShowThirdSectionRight(true), currentTime));
    
    currentTime += 5000;
    timeouts.push(setTimeout(() => {
      setFadeOutThirdP(true);
      setFadeOutThirdSectionRight(true);
      setShowFourthP(true);
    }, currentTime));

    currentTime += 500;
    timeouts.push(setTimeout(() => {
      setHideThirdP(true);
      setHideThirdSectionRight(true);
    }, currentTime));

    currentTime += 3000;
    timeouts.push(setTimeout(() => setShowFourthSectionRight(true), currentTime));
    
    currentTime += 5000;
    timeouts.push(setTimeout(() => {
      setFadeOutFourthP(true);
      setFadeOutFourthSectionRight(true);
      setFadeOutTransactionsBox(true);
      setShowFifthP(true);
    }, currentTime));
        
    currentTime += 3000;
    timeouts.push(setTimeout(() => onComplete?.(), currentTime));
    
    return () => timeouts.forEach(clearTimeout);
  }, [onComplete]);

  return (
    <>
      <h1 className="animate-fade-in">Balanced Equation</h1>
      
      <div className="animation-section">
        {!hideIntroP && (
          <p className={`animation-content ${fadeOutIntroP ? 'animation-content--exiting' : ''} ${getAnimationClass(showIntroP, fadeOutIntroP)}`}>
            A big part of your course is figuring out how business transactions affect financial statements.
          </p>
        )}

        {showSecondP && !hideSecondP && (
          <p className={`animation-content ${fadeOutSecondP ? 'animation-content--exiting' : ''} ${getAnimationClass(showSecondP, fadeOutSecondP)}`}>
            And it gets tricky when you layer in other decisions to consider.
          </p>
        )}

        {showThirdP && !hideThirdP && (
          <p className={`animation-content ${fadeOutThirdP ? 'animation-content--exiting' : ''} ${getAnimationClass(showThirdP, fadeOutThirdP)}`}>
            This exercise uses <b>the accounting equation</b> to simplify and help you see the big picture.
          </p>
        )}

        {showFourthP && !showFifthP && (
          <p className={`animation-content ${fadeOutFourthP ? 'animation-content--exiting' : ''} ${getAnimationClass(showFourthP, fadeOutFourthP)}`}>
            It breaks the decision making into steps, and you'll start by deciding how each transaction <b>increases or decreases the accounting equation from the equity perspective</b>.
          </p>
        )}

        {showFifthP && (
          <p className={getAnimationClass(showFifthP)}>
            You've got <b>up to {numberOfAttempts} attempts</b>, so no stress. Each try will help you build confidence and clarity.
          </p>
        )}
      </div>

      {showTransactionsBox && (
        <div className={`transition-transactions-financial-statements no-stretch ${getAnimationClass(true, fadeOutTransactionsBox)}`}>
          <TransactionsBox />
          
          <div className="animation-section right-side-section">
            {!hideFirstSectionRight && (
              <div className={`animation-content ${fadeOutFirstSectionRight ? 'animation-content--exiting' : ''}`}>
                <div className={`transition-transactions-financial-statement financial-statement ${getAnimationClass(showFirstSectionRight, fadeOutFirstSectionRight)}`}>
                  <h3>What's the Financial Statement Impact</h3>
                </div>
              </div>
            )}

            {showSecondSectionRight && !hideSecondSectionRight && (
              <div className={`animation-content ${fadeOutSecondSectionRight ? 'animation-content--exiting' : ''}`}>
                <div className={`transition-transactions-financial-statement financial-statement ${getAnimationClass(showSecondSectionRight, fadeOutSecondSectionRight)}`}>
                  <ul>
                    <li>Which Accounts are impacted?</li>
                    <li>Do they increase or decrease?</li>
                    <li>Should they be debited or credited?</li> 
                  </ul>
                </div>
              </div>
            )}

            {showThirdSectionRight && !hideThirdSectionRight && (
              <div className={`animation-content ${fadeOutThirdSectionRight ? 'animation-content--exiting' : ''}`}>
                <div className={`transition-transactions-financial-statement-formula-container ${getAnimationClass(showThirdSectionRight, fadeOutThirdSectionRight)}`}>
                  <h4>How does the Transaction Impact the Accounting Equation?</h4>
                  <AccountingEquation firstSign="equals" secondSign="plus" />
                </div>
              </div>
            )}

            {showFourthSectionRight && (
              <div className={`animation-content ${fadeOutFourthSectionRight ? 'animation-content--exiting' : ''}`}>
                <div className={`transition-transactions-financial-statement-formula-container ${getAnimationClass(showFourthSectionRight, fadeOutFourthSectionRight)}`}>
                  <p><b>Level 1:</b> Make Increase or Decrease Decisions</p>
                  <AccountingEquation firstSign="minus" secondSign="equals" />
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}